import VideoStrikethroughIcon from '@atlaskit/icon-lab/core/video-strikethrough';
import * as React from 'react';

export function SvgVideoOff() {
  return <VideoStrikethroughIcon label="" testId="ads-refreshed-icon" />;
}
